import { render, staticRenderFns } from "./Destinationlist.vue?vue&type=template&id=1220f5f2&scoped=true&"
import script from "./Destinationlist.vue?vue&type=script&lang=js&"
export * from "./Destinationlist.vue?vue&type=script&lang=js&"
import style0 from "./Destinationlist.vue?vue&type=style&index=0&id=1220f5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1220f5f2",
  null
  
)

export default component.exports